import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Container, Eyebrow, Reveal } from './landing/primitives';

const testimonials = [
  { quote: 'OpenSov AI has fundamentally changed how our engineering team approaches complex problems. The speed and accuracy are remarkable.', name: 'Arjun Mehta', role: 'CTO, Nexus Technologies', avatar: 'https://images.pexels.com/photos/7366187/pexels-photo-7366187.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=150&w=150' },
  { quote: 'We replaced three separate AI tools with OpenSov and our team productivity increased 4x. The enterprise controls gave us the security we needed.', name: 'Priya Sharma', role: 'VP Engineering, Scale Systems', avatar: 'https://images.pexels.com/photos/4755024/pexels-photo-4755024.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=150&w=150' },
  { quote: 'The API is incredibly well-designed. We integrated OpenSov into our platform in under a day — the streaming support is best-in-class.', name: 'Rahul Verma', role: 'Lead Developer, CloudFirst', avatar: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=150&w=150' },
];

const Testimonials = () => {
  const [active, setActive] = useState(0);
  const t = testimonials[active];

  return (
    <section className="py-24 lg:py-32 border-t border-line" id="company" data-testid="testimonials-section">
      <Container>
        <Reveal className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <Eyebrow className="lg:col-span-3">Trusted by builders</Eyebrow>
          <div className="lg:col-span-9">
            <AnimatePresence mode="wait">
              <motion.blockquote
                key={active}
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                className="min-h-[200px]"
                data-testid="testimonial-quote"
              >
                <p className="text-2xl sm:text-3xl lg:text-[2.5rem] font-heading font-medium tracking-tight leading-[1.25] text-content">
                  “{t.quote}”
                </p>
                <footer className="mt-10 flex items-center gap-4">
                  <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover grayscale" loading="lazy" />
                  <div>
                    <p className="text-sm font-medium text-content">{t.name}</p>
                    <p className="text-xs text-content-3 mt-0.5">{t.role}</p>
                  </div>
                </footer>
              </motion.blockquote>
            </AnimatePresence>

            <div className="mt-12 flex flex-wrap gap-x-8 gap-y-3 border-t border-line pt-6">
              {testimonials.map((item, idx) => (
                <button
                  key={item.name}
                  onClick={() => setActive(idx)}
                  className={`text-sm transition-colors duration-300 ${idx === active ? 'text-content' : 'text-content-3 hover:text-content-2'}`}
                  data-testid={`testimonial-${idx}`}
                >
                  <span className="font-mono text-[11px] mr-2">0{idx + 1}</span>{item.name}
                </button>
              ))}
            </div>
          </div>
        </Reveal>
      </Container>
    </section>
  );
};

export default Testimonials;
